import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import TextButton from '@ui/buttons/TextButton.tsx';

import HandlerContext from '../handlerContext.tsx';

const Wrapper = styled.div`
  height: 85px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-inline-start: 22px;
  margin: ${({ $mobile }) => ($mobile ? `16px -12px 104px` : `16px -12px 24px`)};
  border-top: 1px solid var(--color-primary-10);
`;

const StyledTextButton = styled(TextButton)`
  width: 100px;
  margin-block: 0;
  margin-inline: 0px 10px;
  font-size: 14px !important;
  text-decoration: none;
  font-weight: 500;
  color: var(--color-primary);
  border-radius: 2px;
  padding: 10px;
  transition: color background-color 80ms ease-in;

  &:active:hover {
    color: white;
    background-color: var(--color-primary);
  }
  :focus-visible {
    outline: 2px solid var(--color-primary);
  }
  :hover {
    background-color: var(--color-primary-10);
    color: var(--color-primaryButton);
  }
`;

const StyledText = styled.h3`
  font-size: 12px !important;
  font-weight: 600 !important;
`;

const ButtonWrapper = styled.div`
  width: 100px;
  position: relative;
  inset-inline-start: -12px;
  display: flex;
  justify-content: space-between;
`;
const PoiFeedback = ({ poi, T, hidePoiFeedback, venueId, mobile }) => {
  const [hasResponsed, setHasResponded] = useState(false);
  const responseTextRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (hasResponsed) {
      window.requestAnimationFrame(() => responseTextRef.current?.focus());
    }
  }, [hasResponsed]);

  const responseClickHandler = () => {
    setTimeout(() => setHasResponded(true), 400);
  };

  if (hidePoiFeedback?.includes('*') || hidePoiFeedback?.includes(poi.category)) {
    return null;
  }

  return (
    <HandlerContext.Consumer>
      {ctx => (
        <Wrapper data-testid="PoiFeedbackWrapper" $mobile={mobile}>
          {!hasResponsed ? (
            <>
              <StyledText data-testid="PromptText">{T('poiView:Is this information correct?')}</StyledText>
              <ButtonWrapper>
                <StyledTextButton
                  data-testid="FeedbackButton"
                  onClick={() => {
                    responseClickHandler();
                    ctx.submitPoiFeedback('yes', poi, venueId);
                  }}
                >
                  {T('poiView:Yes')}
                </StyledTextButton>
                <StyledTextButton
                  data-testid="FeedbackButton"
                  onClick={() => {
                    responseClickHandler();
                    ctx.submitPoiFeedback('no', poi, venueId);
                  }}
                >
                  {T('poiView:No')}
                </StyledTextButton>
              </ButtonWrapper>
            </>
          ) : (
            <StyledText data-testid="ResponseText" ref={responseTextRef} tabIndex={-1}>
              {T('poiView: Thank you for your feedback!')}
            </StyledText>
          )}
        </Wrapper>
      )}
    </HandlerContext.Consumer>
  );
};

export default PoiFeedback;
